// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"44":"192a6e08","60":"f29bcdc2","73":"d86f6f79","182":"616afe63","185":"702c443d","362":"d7018787","453":"4ffc6229","615":"fa219286","644":"d9c5af24","775":"6b66a9e4","798":"beb49362","825":"6d9bf086"}[chunkId] + ".chunk.js";
};